module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-regular-400.woff2?21cb8f55d8e0c5b89751a73a45c9bff5";